import productConfig from '@config/product.config';
import i18n from '@assets/i18n/index';
import useUserInfo from '@apis/hooks/account/useUserInfo';

export const shutdown = function () {
    if (window.Intercom) {
        window.Intercom('shutdown');
    }
};

export const shutup = function () {
    const { email, name, id, signupSource } = useUserInfo();

    if (window.Intercom) {
        window.Intercom('boot', {
            app_id: 's36cqmu2',
            email,
            user_id: id,
            name,
            signup_source: signupSource
        });
    }
};

/**
 * 操作类型
 * Intercom API：https://developers.intercom.com/docs/configuration
 */
export const operation = function (type) {
    // Intercom type: ['show','showMessages','showNewMessage','hide']
    if (window.Intercom) {
        window.Intercom(type);
    }
};

export const contact = function () {
    if (window.Intercom) {
        operation('show');
    } else if (window.SibConversations) {
        window.SibConversations('openChat');
        showSendInBlue();
    } else {
        triggerEmail();
    }
};

const triggerEmail = function () {
    let a = document.querySelector('#contact_us');
    if (a) {
        a?.click?.();
    } else {
        const { email } = productConfig[i18n?.global?.locale?.toLowerCase?.() ?? 'jp'] || {};
        if (email) {
            let a = document.createElement('a');
            a.setAttribute('id', 'contact_us');
            a.setAttribute('href', `mailto: ${email}`);
            a.style.visibility = 'hidden';
            document.body.appendChild(a);
            a.click();
        }
    }
};

function update(email: string, uid?: string) {
    window?.Intercom?.('update', {
        email: email,
        user_id: uid
    });
}

export function sendInBlue(type: 'show' | 'hide' | 'openChat') {
    if (window.SibConversations) {
        window.SibConversations(type);
    }
}

export function hideIntercomIcon() {
    document.body.classList.add('hide-intercom');
    // window.Intercom?.('update', { hide_default_launcher: true });
}

export function showIntercomIcon() {
    document.body.classList.remove('hide-intercom');
    // window.Intercom?.('update', { hide_default_launcher: false });
}

export function closeIntercomNotifications() {
    const notificationsFrame: HTMLIFrameElement | null =
        document.querySelector('.intercom-notifications-frame') ||
        document.querySelector('.intercom-borderless-frame') ||
        document.querySelector('.intercom-chat-frame') ||
        document.querySelector('.intercom-note-frame') ||
        document.querySelector('.intercom-pointer-frame') ||
        document.querySelector('.intercom-story-frame') ||
        document.querySelector('.intercom-tour-frame');

    if (notificationsFrame) {
        notificationsFrame.style.display = 'none';
    }
}

export function hideSendInBlue() {
    // sendInBlue('hide');
    document.body.classList.add('hide-sendInBlue');
}

export function showSendInBlue() {
    // sendInBlue('show');
    document.body.classList.remove('hide-sendInBlue');
}

export default {
    contact,
    operation,
    shutdown,
    shutup,
    update
};
